import api from '../api/axios';

export const addClient = (formData) => api.post('/addClient', formData).then((r) => r.data);
export const getClientsList = () => api.get('/ClientsList').then((r) => r.data);
export const getClientById = (id) => api.get(`/ClientsList/${id}`).then((r) => r.data);
export const getClientDetails = () => api.get('/clientDetails').then((r) => r.data);
export const deleteClient = (id) => api.delete(`/deleteClient/${id}`).then((r) => r.data);
export const getClientDataToUpdate = (id) => api.get(`/getClientdatatoUpdate/${id}`).then((r) => r.data);
export const updateClient = (id, body) => api.put(`/UpdateClient/${id}`, body).then((r) => r.data);
export const assignClient = (userId, clientId) => api.post(`/assignClient/${userId}/${clientId}`).then((r) => r.data);
export const unassignClient = (userId, clientId) => api.post(`/unassignClient/${userId}/${clientId}`).then((r) => r.data);
export const importClients = (rows) => api.post('/api/clients/import', { rows }).then((r) => r.data);
export const getTlClients = (userId) => api.get(`/TlClients/${userId}`).then((r) => r.data);
